// removed by extract-text-webpack-plugin
module.exports = {"root":"ParagraphFullImage-module-root-3k1RQ","caption":"ParagraphFullImage-module-caption-JMSLH","img":"ParagraphFullImage-module-img-At2CJ","cta-wrap":"ParagraphFullImage-module-cta-wrap-3DyPC","ctaWrap":"ParagraphFullImage-module-cta-wrap-3DyPC"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/TechnicalDocument/components/ParagraphFullImage/ParagraphFullImage.module.scss
// module id = 1319
// module chunks = 0